import React from 'react';
import CssFilterConverter from 'css-filter-converter';
import PropTypes from 'prop-types';

const TauriImage = ({ localImage, externalImage, alt, className, onClick, color }) => {
    const baseUrl = process.env.PUBLIC_URL || '';

    return (
        <img
            src={localImage ? `${baseUrl}${localImage}` : externalImage}
            alt={alt}
            className={className}
            onClick={onClick}
            style={{ filter: color ? CssFilterConverter.hexToFilter(color).color : "none" }}
        />
    );
};

TauriImage.propTypes = {
    localImage: PropTypes.string,
    externalImage: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    color: PropTypes.string, // Added color as a prop
};

TauriImage.defaultProps = {
    localImage: null,
    externalImage: null,
    className: '',
    onClick: null,
    color: null,
};

export default TauriImage;
